import { axiosGet } from '../util/api'
import { Dispatch } from 'redux'
import {
    SET_CARDS,
    SET_CARDS_LOADING,
    SET_DEFAULT_CARD,
    SetCardsAction,
    SetCardsLoadingAction,
    SetDefaultCardAction,
} from '../constants/reducers/cards'

export type CardAction = SetCardsLoadingAction | SetDefaultCardAction | SetCardsAction

export const setLoading = (loading: boolean): SetCardsLoadingAction => ({
    type: SET_CARDS_LOADING,
    loading,
    receivedAt: Date.now(),
})

export const setDefaultCard = (card: Models.Card): SetDefaultCardAction => ({
    type: SET_DEFAULT_CARD,
    card,
    receivedAt: Date.now(),
})

export const setCards = (cards: Models.Card[]): SetCardsAction => ({
    type: SET_CARDS,
    cards,
    receivedAt: Date.now(),
})

export function fetchCards() {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoading(true))
        axiosGet('billing/cards')
            .then((res) => res.data)
            .then((res) => {
                dispatch(setDefaultCard(res.default))
                dispatch(setCards(res.data))
                dispatch(setLoading(false))
            })
            .catch((res) => {
                console.log('caught error', res)
                dispatch(setLoading(false))
            })
    }
}
